module.exports = __webpack_public_path__ + "static/genesis_noir-2a44f5b3a32b913d9170fcfdded15d8d.webp";